import React from 'react';
import {colors} from '../../styles/colors';
import DefaultText from './DefaultText';
import {minmax} from 'utils/minmax';

/**
 * 푸터 컴포넌트의 Props 타입
 * @property {boolean} [isNarrow] - 좁은 화면 여부
 * @property {boolean} [isMain] - 메인 페이지 여부
 */
type Props = {
  isNarrow?: boolean;
  isMain?: boolean;
};

/**
 * 푸터 컴포넌트
 * 페이지 하단에 표시되는 푸터 컴포넌트입니다.
 * @param {Props} props - 푸터 컴포넌트의 props
 * @returns {JSX.Element} 푸터 컴포넌트
 */
const Footer = ({isNarrow, isMain}: Props) => {
  return (
    <>
      {!isMain ? (
        <DefaultText
          text="copyright"
          textStyle={{
            width: '100%',
            color: colors.gray,
            fontSize: isNarrow ? minmax(18) : 'max(9px, min(1vw, 18px))',
            margin: 'max(20px, min(2vw, 40px)) 0',
            textAlign: 'center',
          }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderTop: '1px solid #DBDBDB',
          }}>
          <DefaultText
            text="footer"
            textStyle={{
              fontSize: minmax(12, 10),
              color: colors.darkGray,
              textAlign: 'center',
              fontWeight: 300,
              padding: `${minmax(15)} ${minmax(10)}`,
            }}
          />
        </div>
      )}
    </>
  );
};

export default Footer;
